import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripLines } from '@fortawesome/free-solid-svg-icons'
import WidthSelector from '../WidthSelector/WidthSelector';
import 'bootstrap/dist/css/bootstrap.css';
import './Analytics.css'

import CustomerRevenueAndHourlyRate from '../Widgets/Library/CustomerRevenueAndHourlyRate'
import ServiceRevenueAndHourlyRate from '../Widgets/Library/ServiceRevenueAndHourlyRate'
import BackOfficeRevenueAndHourlyRate from '../Widgets/Library/BackOfficeRevenueAndHourlyRate'
import TeamRevenueAndHourlyRate from '../Widgets/Library/TeamRevenueAndHourlyRate'
import CustomerAnalyticsSnapshot from '../Widgets/Library/CustomerAnalyticsSnapshot'
import ServiceAnalyticsSnapshot from '../Widgets/Library/ServiceAnalyticsSnapshot'
import BackOfficeAnalyticsSnapshot from '../Widgets/Library/BackOfficeAnalyticsSnapshot'
import TeamAnalyticsSnapshot from '../Widgets/Library/TeamAnalyticsSnapshot'

class AnalyticsWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            width: this.props.width,
            height: 1,
            callback: null
        };
    }

    getWidthName = (width) => {
        this.props.log('AnalyticsWidget.js/getWidthName (width)', width);
        switch (width) {
            case 4: return "Small";
            case 6: return "Medium";
            case 12: return "Large";
            default: return "";
        }
    }

    getModule = (module) => {
        this.props.log('AnalyticsWidget.js/getWidthName (module)', module);
        switch (module) {
            case "CustomerRevenueAndHourlyRate":
                return <CustomerRevenueAndHourlyRate {...this.props} callback={this.callback}  />
            case "ServiceRevenueAndHourlyRate":
                return <ServiceRevenueAndHourlyRate {...this.props} callback={this.callback}  />
            case "BackOfficeRevenueAndHourlyRate":
                return <BackOfficeRevenueAndHourlyRate {...this.props} callback={this.callback}  />
            case "TeamRevenueAndHourlyRate":
                return <TeamRevenueAndHourlyRate {...this.props} callback={this.callback}  />
            case "CustomerAnalyticsSnapshot":
                return <CustomerAnalyticsSnapshot {...this.props} callback={this.callback}  />
            case "ServiceAnalyticsSnapshot":
                return <ServiceAnalyticsSnapshot {...this.props} callback={this.callback}  />
            case "BackOfficeAnalyticsSnapshot":
                return <BackOfficeAnalyticsSnapshot {...this.props} callback={this.callback}  />
            case "TeamAnalyticsSnapshot":
                return <TeamAnalyticsSnapshot {...this.props} callback={this.callback}  />
            default:
                return <></>
        }
    }

    callback = (cb) => {
        this.props.log('AnalyticsWidget.js/callback (cb)', cb);
        this.setState({
            callback: cb
        });
    }

    render() {
        this.props.info('AnalyticsWidget.js/render');
        return (
            <Col md={this.props.width} className={"widget p-3" + (this.props.active ? "" : " d-none")}>
                <Card className={"widgetHeight" + this.state.height}>
                    <CardHeader className="dragDiv">
                        <Row>
                            <Col className="d-flex flex-shrink-1 flex-grow-0 align-right p-0">
                                <WidthSelector
                                    widths={this.props.widths}
                                    width={this.state.width}
                                    log={this.props.log}
                                    info={this.props.info}
                                    callback={(width) => {if (this.state.callback) this.state.callback(width); this.props.handleChange(this.props.id, 'width', width);}}
                                />
                            </Col>
                            <Col className="d-flex flex-shrink-0 flex-grow-1 text-center justify-content-center  px-1">
                                <h5>{this.props.name}</h5>
                            </Col>
                            <Col className="d-flex flex-shrink-1 flex-grow-0 align-left p-0">
                                <div className="dragIcon px-2"><FontAwesomeIcon icon={faGripLines} /></div>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        {this.getModule(this.props.widget.module)}
                    </CardBody>
                </Card>
            </Col>
        );
    }
}

export default AnalyticsWidget;
